
enum ModalType {
  ITEM,
  MANUFACTURER,
  LICENSE,
}

export default ModalType
